import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const earningManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all earnings
    getAllEarnings: builder.query({
      query: () => ({
        url: "qwikITEarning/",
        method: "GET",
      }),
      providesTags: ["earnings"],
      transformResponse: response => response,
    }),

    // Get a single earning by ID
    getEarning: builder.query({
      query: id => ({
        url: `qwikITEarning/${id}/`,
        method: "GET",
      }),
      providesTags: ["earnings"],
      transformResponse: response => response,
    }),

    // Create a new earning
    createEarning: builder.mutation({
      query: data => ({
        url: "qwikITEarning/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["earnings"],
      transformResponse: response => {
        toast.success("Earning added successfully");
        return response;
      },
    }),

    // Update earning
    updateEarning: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `qwikITEarning/${id}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["earnings"],
      transformResponse: response => {
        toast.success("Earning updated successfully");
        return response;
      },
    }),

    // Delete earning
    deleteEarning: builder.mutation({
      query: id => ({
        url: `qwikITEarning/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["earnings"],
      transformResponse: response => {
        toast.success("Earning deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllEarningsQuery,
  useGetEarningQuery,
  useCreateEarningMutation,
  useUpdateEarningMutation,
  useDeleteEarningMutation,
} = earningManagementApi;